import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/ccsApi";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        // If already logged in, go to dashboard
        api.get("/auth/me").then(() => nav("/admin")).catch(() => {});
    }, [nav]);

    async function submit(e) {
        e.preventDefault();
        setSubmitting(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.token) {
                localStorage.setItem("ccs_admin_token", data.token);
            }
            toast.success("Welcome back");
            nav("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-10 bg-[#F8FAFC]">
            <form
                onSubmit={submit}
                className="w-full max-w-md bg-white rounded-2xl border border-[#E2E8F0] p-8 shadow-sm"
                data-testid="admin-login-form"
            >
                <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-full bg-[#1E3A8A] text-white flex items-center justify-center"><Lock className="h-5 w-5" /></div>
                    <div>
                        <h1 className="font-heading font-bold text-xl text-[#0F172A]">Admin sign in</h1>
                        <p className="text-sm text-slate-500">CCS Cost Calculator Australia</p>
                    </div>
                </div>

                <div className="mt-6 space-y-4">
                    <div>
                        <Label className="text-sm">Email</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 min-h-[44px]" data-testid="input-admin-email" />
                    </div>
                    <div>
                        <Label className="text-sm">Password</Label>
                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 min-h-[44px]" data-testid="input-admin-password" />
                    </div>
                </div>

                <Button type="submit" disabled={submitting} className="mt-6 w-full ccs-btn-secondary rounded-full" data-testid="submit-admin-login">
                    <LogIn className="h-4 w-4 mr-2" /> {submitting ? "Signing in…" : "Sign in"}
                </Button>
            </form>
        </div>
    );
}
